// extracted by mini-css-extract-plugin
module.exports = {"confirmation-table":"ConfirmationTable_confirmation-table__hJSAu"};